import React from 'react';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import Edit from '@material-ui/icons/Edit';
import useStyles from './index.style';

const Stateroom = (props) => {
  const classes = useStyles();
  const {
    bookingId,
    courtesyHold,
    guarantee,
    guests,
    deckPosition,
    type,
    deck,
    room,
    index,
    dictionaries,
    stateroomEditClick,
  } = props;

  return (
    <Container maxWidth="lg" className={classes.stateroom}>
      <Box className="card">
        <Typography className="roomLength">
          {dictionaries.room} {index}
        </Typography>
        <Paper square>
          <Typography className="resNumber">
            {dictionaries.reservation} #{bookingId}
          </Typography>
          <Box className="info">
            {guests > 0 && (
              <Typography component="span">
                {guests} {dictionaries.guests}
              </Typography>
            )}
            {guarantee && <Typography component="span">{dictionaries.guarantee}</Typography>}
            {!guarantee && type && <Typography component="span">{type}</Typography>}
            {!guarantee && deckPosition && <Typography component="span">{deckPosition}</Typography>}
            {!guarantee && deck && (
              <Typography component="span">
                {dictionaries.deck} {deck.code}
              </Typography>
            )}
            {!guarantee && room && <Typography component="span">{room}</Typography>}
          </Box>
          {!courtesyHold && (
            <Link className="editButton" onClick={stateroomEditClick}>
              <Edit /> <Box component="span">{dictionaries.edit}</Box>{' '}
            </Link>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default Stateroom;
